export function buildImgixUrl(
  imageUrl: string,
  height: number | "auto" = 1500,
  width: number | "auto" = 1500,
  fit = "clip",
  maxWidth = 2500,
  minWidth = 1500
) {
  if (!imageUrl || !process.env.IMGIX_SOURCE) return imageUrl;

  if (imageUrl.includes("imgix.net"))
    imageUrl = imageUrl.replace(/(.*)\.imgix\.net(\/)/, "");
  else {
    imageUrl = imageUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");
    imageUrl = imageUrl.replace(
      /(s3-|s3\.)?(.*)\.amazonaws\.com(\/(.*?)\/)/,
      ""
    );
  }

  const imgixUrlWithDimension = `https://${process.env.IMGIX_SOURCE}/${imageUrl}?auto=format,compress&fit=${fit}&h=${height}&w=${width}&max-w=${maxWidth}&min-w=${minWidth}`;

  return imgixUrlWithDimension;
}
